/**
 * وظائف مساعدة للتعامل مع أيقونة الموقع (Favicon)
 */

/**
 * تحديث أيقونة الموقع (Favicon) في صفحة HTML
 * @param faviconUrl رابط الأيقونة الجديدة
 */
export const updateFavicon = (faviconUrl: string | undefined): void => {
  if (!faviconUrl) return;

  // البحث عن عنصر الأيقونة الحالي
  let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
  
  // إنشاء عنصر جديد إذا لم يكن موجودًا
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  
  // تحديث رابط الأيقونة
  link.href = faviconUrl;
};

/**
 * استعادة أيقونة الموقع الافتراضية
 */
export const restoreDefaultFavicon = (): void => {
  // البحث عن عنصر الأيقونة الحالي
  const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

  if (link) {
    // إعادة تعيين الرابط إلى الأيقونة الافتراضية
    link.href = '/favicon.ico';
  }
};

/**
 * استعادة أيقونة لوحة التحكم الافتراضية
 */
export const restoreAdminFavicon = (): void => {
  restoreDefaultFavicon();
};
